module.exports = {
  URL: {
    API_BASE_URL: { WHITE_BLOB: process.env.REACT_APP_API_BASE_URL_WHITE_BLOB },
  },
};
